export default "__VITE_ASSET__rT$pR$Ms__"